import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TierPromotionCard from '../../../TierPromotionCard';
import { DeviationLink } from '../../../../Duperbrowse';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './Tier.scss';
var Tier = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, className = _a.className, style = _a.style;
    var t = useTranslation().t;
    var a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    return (React.createElement("div", { style: __assign({ width: width,
            height: height }, style), className: classnames(s['root'], className) },
        React.createElement(TierPromotionCard, { deviation: deviation, width: width, height: height }),
        React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title, "aria-label": a11yLabel },
            React.createElement("span", null))));
};
Tier.displayName = 'TierThumb';
export default Tier;
//# sourceMappingURL=Tier.js.map